export const getters = {
    getUserSetting: state => state.userConfiguration.setting,
    getUserOnboarding: state => state.userConfiguration.onboarding,
    getUserAssets: state => state.userConfiguration.setting.assets,
    getLineID: state => state.userConfiguration.lineid,
    getGlobalOnboarding: state => state.globalConfiguration,
    getOnboarding: state => {
        if (state.globalConfiguration.onboarding) {
            return state.globalConfiguration.onboarding
                .filter(globalConfiguration =>
                    !state.userConfiguration.onboarding
                        .some(userConfiguration =>
                            userConfiguration.id === globalConfiguration.id &&
                            globalConfiguration.mode !== 'alway'
                        )
                )
                .map(globalConfiguration => ({
                    id: globalConfiguration.id,
                    skip: false
                }))
        } else {
            return []
        }
    },
    getCompareOnboarding: state => {
        return state.userConfiguration.onboarding.length === state.globalConfiguration.onboarding.length
    },
    getPDPA: state => state.userConfiguration.pdpa
}
